import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import MxVideoPlayer from 'mx-video-player';
import Timecode from 'mx-video-timecode';

import {setVideoSoundItem} from '../../actions';
import * as util from './util';
import {Config, LogoUrl} from '../../util';

class VideoItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      info: '',
      url: '',
      live: false,
      videoCurrentTime: '',
      videoItem: {},
      volumeFlag: false
    };

    this.startFromSec = 0;
    
    this.VIDEO_TIMER = undefined;

    this.handleOnLoadStart = this.handleOnLoadStart.bind(this);
    this.handleOnLoadedMetadata = this.handleOnLoadedMetadata.bind(this);
    this.handleOnPlay = this.handleOnPlay.bind(this);
    this.handleOnPause = this.handleOnPause.bind(this);
    this.handleOnEnded = this.handleOnEnded.bind(this);
    this.handleOnVolume = this.handleOnVolume.bind(this);

    this.handleOnVideoClose = this.handleOnVideoClose.bind(this);
  }


  shouldComponentUpdate (nextProps, nextState) {
    if(nextProps.selectedMenu === "DIVISION"){
      return false;
    }
    if(!_.isEqual(this.props.videoItem, nextProps.videoItem)) {
      this.setState({videoItem: nextProps.videoItem},()=>this.$player = this.player);
      // this.$player = this.player;
      return true;
    }
    if(!_.isEqual(this.state.videoItem, nextState.videoItem)) {
      if(this.state.videoItem.start !== nextState.videoItem.start && !nextState.videoItem.live) {
        this.setStartPosition(nextState.videoItem);
      }
      return true;
    }
    
    if(this.state.videoCurrentTime !== nextState.videoCurrentTime) {
      return true;
    }
    return false;
  }
  componentWillReceiveProps(nextProps) {
    if(this.props.selectedMenu !== nextProps.selectedMenu){ // 메뉴 변경시 음소거 (분할메뉴 선택시)
      if(nextProps.selectedMenu === "DIVISION" || this.props.selectedMenu === "DIVISION"){
        if(this.player) {
          this.player.dom.volume = 0;
        }
      }
    }else{
      if(this.props.activeVideo !== nextProps.activeVideo){
        if(nextProps.activeVideo === nextProps.id){
          if(this.player) {
            this.player.dom.volume = 1;
          }
        }else {
          if(this.player) {
            this.player.dom.volume = 0;
          }
        }
      }else{
        if(this.player) {
          // this.player.dom.volume = 1;
          // preView close일 경우와 팝업플레이어 창 열기인 경우 mute.
          if(nextProps.videoFlag && !nextProps.modalFlag){
          }else{
            this.player.dom.volume = 0;
          }
        }
    }
    }

    // else if(nextProps.activeVideoType === 'Item'){
    //   if(nextProps.activeVideo === nextProps.id){
    //     if(this.player) {
    //       this.player.dom.volume = 1;
    //     }
    //   }else{
    //     if(this.player) {
    //       this.player.dom.volume = 0;
    //     }
    //   }
    // }
  }


  isVaildProps(nextProps){
    const {
      id,
      videoItem
    } = this.props;
    // NOTE: if 조건: 
    // 1) 새 videoItem의 undefined, 빈 객체 여부
    // 2) 새 videoItem
    // 3) 처음 설정한 url에 해당하는 편성이 한시간 이상 편성이라서
    //    VideoItem 컴포넌트 내부에서 url값이 바뀐 경우(this.state.url이 props의 개입없이 변함.)
    return (
      !_.isEmpty(nextProps.videoItem) 
      && (
        !_.isEqual(videoItem, nextProps.videoItem)
        || !_.isEqual(this.state.url, nextProps.videoItem.live ? nextProps.videoItem.hls : nextProps.videoItem.url)
      )
    );
  }

  handleOnLoadStart(){
  }
  handleOnLoadedMetadata() {
    const {videoItem} = this.state;
    if(!videoItem.live){
      this.setStartPosition(videoItem);
    }
  }
  handleOnPlay() {
    this.displayCurrentTime();
  }
  handleOnPause () {
    // clearInterval(this.VIDEO_TIMER);
  }
  handleOnEnded(){
    clearInterval(this.VIDEO_TIMER);
    const {
      videoCurrentTime,
      videoItem
    } = this.state;

    if(util.checkPlayContinously(videoCurrentTime, videoItem)) {

    }
  }
 
  handleOnVolume(e){
    const vdom = this.player.dom;
    this.props.handleMute(this.props.id, vdom.volume);
  }
  

  setStartPosition(videoItem) {
    const vodSTime = moment(videoItem.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss');
    let second = (Number(vodSTime.split(':')[2]));
    second = second + 0.016265;
    this.startFromSec = (Number(vodSTime.split(':')[1])*60) + (second);
    
    if(this.player){
      // this.startFromSec = util.setStartFrom(videoItem);
      this.player.api.seek(this.startFromSec);
    }
  }
  displayCurrentTime(){
    clearInterval(this.VIDEO_TIMER);
    const {start, live} = this.state.videoItem;
    if(!live) {
      
      const startTime = moment(start, 'YYYYMMDDHHmmss').format('HH:mm:ss');
      const startArr = startTime.split(":");
      // const videoStartTime = Timecode.sec.tc2sec(startTime) - this.startFromSec;
      this.VIDEO_TIMER = setInterval(() => {
        // const currentTime = videoStartTime + Math.floor(this.player.api.currentTime);
        const timeStr = Timecode.fps.sec2tc(this.$player.api.currentTime);
        const timeRest = startArr[0] + ":" + timeStr.split(":").slice(1).join(":");
        this.setState({
          videoCurrentTime: timeRest//Timecode.sec.sec2tc(currentTime)
        });
      }, 100);
    }
  }

  handleOnVideoClose(){
    clearInterval(this.VIDEO_TIMER);
    this.player=null;
    this.setState({videoCurrentTime: '', videoItem: {}});
    this.props.handleClose(this.props.id);
  }

  render() {
    const {
      startTimeSec,
      videoCurrentTime,
      videoInfo,
      videoItem
    } = this.state;

    const {
      id
    } = this.props;

    const {
      url, hls, airDate, live, date
    } = videoItem;
    
    // const channelImage = LogoUrl(videoItem.chname);
    const channelImage = videoItem.chName ? _.keyBy(Config.logoUrl, 'title')[videoItem.chName]
                                          : videoItem.chname ? _.keyBy(Config.logoUrl, 'title')[videoItem.chname]
                                          : '';
    return (
      <div className="item">
        <div className="video">
          {(url || hls) ? <MxVideoPlayer
            ref={(i) => {this.player = i;}}

            debug={true}
            live={live}
            fullscreen={false}
            detection={true}
            alignCenter={true} // 가운데정렬
    
            autoplay={true} // 자동플레이
            autoHide={true}
            id={id}
            className="chrome"
            playsinline='true'
            timecode='smtp' // 영상플레이어 frame 단위 이동
            src={url || hls}
            

            onLoadStart={this.handleOnLoadStart}
            onLoadedMetadata={this.handleOnLoadedMetadata}
            onPlay={this.handleOnPlay}
            onPause={this.handleOnPause}
            onEnded={this.handleOnEnded}
            onVolumeChange={this.handleOnVolume}
          /> : null}
        </div>
        <div className="info">
          <div>
            <img src={channelImage && channelImage.imgBlack} alt={channelImage && channelImage.title} />
          </div>
          {live ? <div className="live">LIVE</div> : <div className="time">{videoCurrentTime}</div>}
          <div className="date">{airDate || date}</div>
        </div>
          {(url || hls) && <div className="video-close" onClick={this.handleOnVideoClose}>
          </div>}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedMenu: state.selectedMenu,
    activeVideo: state.activeVideo,
    videoFlag: state.videoFlag,
    modalFlag: state.modalFlag,
    activeVideoType: state.activeVideoType
  }
};
const mapDispatcherToProps = dispatch => {
  return {
    setVideoSoundItem: (activeVideo) => dispatch(setVideoSoundItem(activeVideo))
  }
};

VideoItem = connect(mapStateToProps,mapDispatcherToProps)(VideoItem);


export default VideoItem;


// WEBPACK FOOTER //
// ./src/components/video/VideoItem.js